import React from 'react';
import hygeaLogo from '../../assets/hygea.png';
import smLogo from '../../assets/sm_logo.png';
import ayalaLogo from '../../assets/ayala.png';
import gmallLogo from '../../assets/gmall.png';
import mactanLogo from '../../assets/mactan.jpg';
import ororamaLogo from '../../assets/ororama.png';

const BRANCH_LOGO_MAP = [
  { match: 'sm', logo: smLogo, alt: 'SM Branch Logo' },
  { match: 'ayala', logo: ayalaLogo, alt: 'Ayala Branch Logo' },
  { match: 'gmall', logo: gmallLogo, alt: 'Gmall Branch Logo' },
  { match: 'mactan', logo: mactanLogo, alt: 'Mactan Branch Logo' },
  { match: 'ororama', logo: ororamaLogo, alt: 'Ororama Branch Logo' },
];

const getStoredUser = () => {
  try {
    const rawUser = localStorage.getItem('user');
    return rawUser ? JSON.parse(rawUser) : null;
  } catch {
    return null;
  }
};

const normalize = (value) => (value || '').toString().toLowerCase();

const getBranchMeta = (branchName) => {
  const normalized = normalize(branchName);
  const branchLogo =
    BRANCH_LOGO_MAP.find((entry) => normalized.includes(entry.match)) ||
    BRANCH_LOGO_MAP[0];
  const displayName = branchName
    ? /\bbranch\b/i.test(branchName)
      ? branchName
      : `${branchName} Branch`
    : 'Unassigned Branch';

  return { name: displayName, logo: branchLogo.logo, alt: branchLogo.alt };
};

const ManagerTopHeader = ({ pageTitle }) => {
  const user = getStoredUser();
  const branchMeta = getBranchMeta(user?.branch_name || user?.branch || '');

  return (
    <header className="bg-white shadow-sm border-b border-gray-200 px-4 sm:px-6 lg:px-8 py-3 sm:py-4">
      <div className="flex items-center justify-between gap-3 min-w-0">

        {/* ── Left: Hygea logo + title ── */}
        <div className="flex items-center gap-2 sm:gap-3 min-w-0">
          <img
            src={hygeaLogo}
            alt="Hygea Wellness Spa"
            className="h-8 sm:h-10 lg:h-12 w-auto object-contain flex-shrink-0"
          />
          <div className="min-w-0">
            {/* Hide full name on very small screens, show abbreviated */}
            <h1 className="font-bold text-gray-800 leading-tight truncate">
              <span className="hidden sm:inline text-lg lg:text-xl">Hygea Wellness Spa</span>
              <span className="inline sm:hidden text-base">Hygea</span>
            </h1>
            {pageTitle && (
              <p className="text-xs sm:text-sm text-gray-500 truncate">{pageTitle}</p>
            )}
          </div>
        </div>

        {/* ── Right: Branch info + logo ── */}
        <div className="flex items-center gap-2 sm:gap-3 flex-shrink-0">
          {/* Branch name — hidden on xs, visible sm+ */}
          <p className="hidden sm:block text-xs sm:text-sm font-semibold text-gray-700 text-right leading-tight max-w-[120px] lg:max-w-none truncate">
            {branchMeta.name}
          </p>
          <img
            src={branchMeta.logo}
            alt={branchMeta.alt}
            className="w-8 h-8 sm:w-10 sm:h-10 lg:w-12 lg:h-12 object-contain rounded"
          />
        </div>

      </div>

      {/* Branch name visible on xs only, shown below the main row */}
      <p className="sm:hidden text-xs text-gray-500 font-medium mt-1 truncate">
        {branchMeta.name}
      </p>
    </header>
  );
};

export default ManagerTopHeader;